// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__-O+5U","clear":"Chip_clear__xrK7W"};